<template>
  <el-row>
    <el-row>
      <el-dialog
        title="设置梯度信息"
        :visible.sync="showGradientDialog"
        :before-close="closeGradient"
        width="75%"
      >
        <el-row style="text-align: center; min-height: 200px">
          <el-row>
            <el-col :span="20" :offset="2">
              <el-form
                :model="GradientListObj"
                ref="GradientList"
                :rules="gradientRules"
                class="gradientListDialog"
              >
                <el-table
                  :data="GradientListObj.GradientList"
                  :header-cell-style="{
                    background: '#f3f6f9',
                    'text-align': 'center',
                  }"
                  :cell-style="{ 'text-align': 'center' }"
                  :border="true"
                >
                  <el-table-column type="index" width="80" label="NO.">
                  </el-table-column>
                  <el-table-column label="CV" v-if="checkCv" width="200">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; flex-direction: column"
                        class="table-form"
                      >
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 10px;
                            width: 100%;
                          "
                          :prop="'GradientList.' + scope.$index + '.begin_cv'"
                          :rules="gradientRules.begin_cv"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >begin</span
                          >
                          <el-input
                            v-model="scope.row.begin_cv"
                            type="mini"
                            style="width: 120px"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 0;
                            width: 100%;
                          "
                          :prop="'GradientList.' + scope.$index + '.end_cv'"
                          :rules="gradientRules.end_cv"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >end</span
                          >
                          <el-input
                            v-model="scope.row.end_cv"
                            type="mini"
                            style="width: 120px"
                            @input="inputCvChange(scope.$index)"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="Time" v-if="!checkCv" width="200">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; flex-direction: column"
                        class="table-form"
                      >
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 10px;
                            width: 100%;
                          "
                          :prop="'GradientList.' + scope.$index + '.begin_time'"
                          :rules="gradientRules.begin_time"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >begin</span
                          >
                          <el-input
                            v-model="scope.row.begin_time"
                            type="mini"
                            style="width: 120px"
                            :disabled="true"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 0;
                            width: 100%;
                          "
                          :prop="'GradientList.' + scope.$index + '.end_time'"
                          :rules="gradientRules.end_time"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >end</span
                          >
                          <el-input
                            v-model="scope.row.end_time"
                            type="mini"
                            style="width: 120px"
                            @input="inputTimeChange(scope.$index)"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="1st" width="150">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'GradientList.' + scope.$index + '.channel_1'"
                        :rules="gradientRules.channel_1"
                      >
                        <el-select
                          v-model="scope.row.channel_1"
                          style="margin-top: 25px; height: 40px"
                          clearable
                          @change="changeFirst(scope.$index)"
                        >
                          <el-option
                            v-for="item in channelListFirst[scope.$index]"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="2nd" width="150">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'GradientList.' + scope.$index + '.channel_2'"
                        :rules="gradientRules.channel_2"
                      >
                        <el-select
                          v-model="scope.row.channel_2"
                          style="margin-top: 25px; height: 40px"
                          clearable
                          @change="changeSecond(scope.$index)"
                        >
                          <el-option
                            v-for="item in channelListSecond[scope.$index]"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="2nd%" width="200">
                    <template slot-scope="scope">
                      <div
                        style="display: flex; flex-direction: column"
                        class="table-form"
                      >
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 10px;
                            width: 100%;
                          "
                          :prop="
                            'GradientList.' + scope.$index + '.begin_percent_2'
                          "
                          :rules="gradientRules.begin_percent_2"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >begin</span
                          >
                          <el-input
                            v-model="scope.row.begin_percent_2"
                            type="mini"
                            style="width: 120px"
                          ></el-input>
                        </el-form-item>
                        <el-form-item
                          style="
                            flex: 1;
                            display: flex;
                            margin-bottom: 0;
                            width: 100%;
                          "
                          :prop="
                            'GradientList.' + scope.$index + '.end_percent_2'
                          "
                          :rules="gradientRules.end_percent_2"
                        >
                          <span
                            style="
                              display: inline-block;
                              width: 30%;
                              word-wrap: break-word;
                              white-space: normal;
                              line-height: 40px;
                              height: 40px;
                            "
                            >end</span
                          >
                          <el-input
                            v-model="scope.row.end_percent_2"
                            type="mini"
                            style="width: 120px"
                            @input="inputPercentChange(scope.$index)"
                          ></el-input>
                        </el-form-item>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="3rd" width="150">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'GradientList.' + scope.$index + '.channel_3'"
                        :rules="gradientRules.channel_3"
                      >
                        <el-select
                          v-model="scope.row.channel_3"
                          style="margin-top: 25px; height: 40px"
                          clearable
                          @change="changeThird(scope.$index)"
                        >
                          <el-option
                            v-for="item in channelListThird[scope.$index]"
                            :key="item.value"
                            :value="item.value"
                            :label="item.label"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="3rd%">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'GradientList.' + scope.$index + '.percent_3'"
                        :rules="gradientRules.percent_3"
                      >
                        <el-input
                          v-model="scope.row.percent_3"
                          type="mini"
                          style="margin-top: 25px"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column label="Flow Rate">
                    <template slot-scope="scope">
                      <el-form-item
                        :prop="'GradientList.' + scope.$index + '.flow_rate'"
                        :rules="gradientRules.flow_rate"
                      >
                        <el-input
                          v-model="scope.row.flow_rate"
                          type="mini"
                          style="margin-top: 25px"
                          @input="inputFlowRateChange"
                        ></el-input>
                      </el-form-item>
                    </template>
                  </el-table-column>
                  <el-table-column>
                    <template slot-scope="scope">
                      <el-button
                        icon="el-icon-delete"
                        type="warning"
                        circle
                        @click="deleteRow(scope.$index)"
                      ></el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </el-form>
            </el-col>
          </el-row>
          <el-row>
            <div style="margin: 20px 0">
              <el-button type="primary" @click="addRow">添加</el-button>
              <el-button type="primary" @click="clickCv">切换</el-button>
              <el-button type="primary" @click="finishGradient">完成</el-button>
            </div>
          </el-row>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <el-dialog
        title="溶剂消耗设置"
        :visible.sync="showSolventsConsume"
        :before-close="closeConsume"
      >
        <el-row>
          <el-col :span="16" :offset="4">
            <el-table :data="MethodInfo.otherInfo.solventsConsume">
              <el-table-column label="名称">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.solvents"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="体积(ml)">
                <template slot-scope="scope">
                  <el-input v-model="scope.row.vol"></el-input>
                </template>
              </el-table-column>
              <el-table-column label="删除">
                <template slot-scope="scope">
                  <el-button
                    icon="el-icon-delete"
                    type="warning"
                    circle
                    @click="deleteSolVolRow(scope.$index)"
                  ></el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
        <el-row style="text-align: center">
          <el-button type="text" @click="addSolVolRow">添加新数据</el-button>
        </el-row>
        <el-row>
          <el-col
            :span="4"
            :offset="10"
            style="margin-bottom: 20px; text-align: center"
          >
            <el-button type="primary" @click="finishConsume">完成</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <el-dialog
        title="溶剂信息"
        :visible.sync="showEluent"
        :before-close="closeEluent"
        class="solvent"
      >
        <el-row
          v-for="(sol, index) in MethodInfo.solvents"
          :key="index"
          style="border-bottom: solid 1px lightgrey; margin-top: 20px"
        >
          <el-form
            label-width="80px"
            :model="sol"
            :rules="EluentRules"
            :ref="`${index - 1}EluentForm`"
          >
            <el-col :span="8">
              <el-form-item label="名称:" prop="nameCh">
                <el-select
                  v-model="sol.nameCh"
                  size="mini"
                  @change="(val) => changeSolvent(val, index)"
                >
                  <el-option
                    v-for="fp in FlowPhase"
                    :key="fp.id"
                    :label="fp.solvent"
                    :value="fp.solvent"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="管道: " prop="channel">
                <el-select
                  v-model="sol.channel"
                  size="mini"
                  @change="channelChange"
                >
                  <el-option
                    v-for="c in channelTypes"
                    :key="c"
                    :value="c"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="极性:" prop="polarity">
                <el-col :span="16">
                  <el-input
                    v-model="sol.polarity"
                    size="mini"
                    :disabled="true"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-col>
          </el-form>
        </el-row>
        <el-row style="text-align: center" class="c_margin_top">
          <el-button type="primary" @click="addEluentFunc">添加</el-button>
          <el-button type="primary" @click="popEluentFunc">删除</el-button>
          <el-button type="primary" @click="finishEluent">完成</el-button>
        </el-row>
      </el-dialog>
    </el-row>
    <el-form
      label-width="120px"
      :model="MethodInfo"
      :rules="rules"
      ref="ruleForm"
    >
      <el-row :gutter="20">
        <el-col :span="2"><h4>方法归属:</h4></el-col>
        <el-col :span="9" style="margin-top: 22px">
          <el-select
            v-model="MethodInfo.method_type"
            size="mini"
            placeholder="请选择方法归属"
          >
            <el-option
              v-for="item in methodType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row>
        <el-col :span="3">
          <h4>色谱柱:</h4>
        </el-col>
        <el-col :span="21" class="c_margin_top">
          <el-row>
            <el-col :span="8">
              <el-form-item label="型号:" prop="flashColumn">
                <el-select
                  v-model="MethodInfo.flashColumn"
                  size="mini"
                  allow-create
                  filterable
                  @change="changeFlashColumn"
                >
                  <el-option
                    v-for="item in FlashColumnList"
                    :key="item.flashColumn"
                    :value="item.flashColumn"
                  ></el-option>
                </el-select>
                <div
                  style="color: red; margin-left: 10px"
                  v-if="!this.$store.state.columnDetail"
                >
                  请完善色谱柱型号详情
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="规格:">
                {{ MethodInfo.columnDetail.catalogueName }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="display: none">
            <el-col :span="4">
              <el-form-item label="填料类型:">
                {{ MethodInfo.columnDetail.fillerLabel }}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="标准分离度:">
                {{ MethodInfo.resolution }}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="标准拖尾因子:">
                {{ MethodInfo.trailingFactor }}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="有效塔板数:">
                {{ MethodInfo.effectivePedals }}
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="display: none">
            <el-col :span="4">
              <el-form-item label="填料孔径:">
                {{ MethodInfo.columnDetail.fillerAperture }}
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="填料粒径:">
                {{ MethodInfo.columnDetail.fillerParticleSize }}
                <!-- <el-input v-model="MethodInfo.columnDetail.fillerParticleSize" style="width: 250px;">
                  <div slot="append">μm</div></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="尺寸(D&L):">
                {{ MethodInfo.columnDetail.size }}
                <!-- <el-input v-model="MethodInfo.columnDetail.size" style="width: 250px;">
                  <div slot="append">μm</div></el-input> -->
              </el-form-item>
            </el-col>
            <el-col :span="4">
              <el-form-item label="分离柱品牌:">
                {{ MethodInfo.columnDetail.brand }}
                <!-- <el-input style="width: 250px;" v-model="MethodInfo.columnDetail.brand" @input='valueChange'></el-input> -->
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="柱体积:">
                {{
                  MethodInfo.columnDetail.cv != ""
                    ? `${MethodInfo.columnDetail.cv}ml`
                    : MethodInfo.columnDetail.cv
                }}
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="耐压:">
                {{
                  MethodInfo.columnDetail.pressure != ""
                    ? `${MethodInfo.columnDetail.pressure}psi`
                    : MethodInfo.columnDetail.pressure
                }}
              </el-form-item>
            </el-col>
      </el-row>
      <el-row>
        <el-col :span="8">
          <el-form-item label="上样量:" prop="loadAmount">
            <el-row style="margin-top: 5px">
              <el-input size="mini" v-model="MethodInfo.loadAmount">
                <template slot="append">
                  <el-select
                    v-model="MethodInfo.loadAmountUnit"
                    class="headsearchselect"
                    placeholder="单位:"
                  >
                    <el-option label="mg" value="mg"></el-option>
                    <el-option label="g" value="g"></el-option>
                  </el-select>
                </template>
              </el-input>
            </el-row>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>

      <el-row :gutter="20">
        <el-col :span="4">
          <h4>检测设置:</h4>
        </el-col>
        <el-col :span="20" class="c_margin_top">
          <el-row>
            <el-col :span="6">
              <el-form-item label="检测设置:">
                <el-select
                  v-model="MethodInfo.detectSetting"
                  size="mini"
                  placeholder=""
                  @change="detectSettingChange"
                >
                  <el-option
                    v-for="item in detectSettingType"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="MethodInfo.detectSetting == '0'">
            <el-col :span="8">
              <el-form-item label="检测波长1:" prop="wavelengthChA">
                <el-input
                  style="margin-top: 7px"
                  size="mini"
                  v-model="MethodInfo.wavelengthChA"
                >
                  <template slot="append">nm</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="检测波长2:" prop="wavelengthChB">
                <el-input
                  style="margin-top: 7px"
                  size="mini"
                  v-model="MethodInfo.wavelengthChB"
                >
                  <template slot="append">nm</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="MethodInfo.detectSetting == '1'">
            <el-col :span="8">
              <el-form-item label="雾化温度:" prop="atomizationTemperature">
                <el-input
                  size="mini"
                  v-model="MethodInfo.atomizationTemperature"
                  style="margin-top: 6px"
                >
                  <template slot="append">℃</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row :gutter="20">
        <el-col :span="3">
          <h4>馏分收集:</h4>
        </el-col>
        <el-col :span="8" class="c_margin_top">
          <el-form-item label="样品收集:">
            <el-select
              v-model="MethodInfo.sampleCollection.collectType"
              size="mini"
            >
              <el-option
                v-for="item in simpleCollectType"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8" class="c_margin_top">
          <el-form-item
            label="容器收集体积:"
            prop="sampleCollection.perCollectVol"
          >
            <el-input
              style="margin-top: 7px"
              v-model="MethodInfo.sampleCollection.perCollectVol"
              size="mini"
            >
              <template slot="append">ml</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="c_margin_top" :gutter="20">
        <el-col :span="3">
          <h4>洗脱信息:</h4>
        </el-col>
        <el-col :span="21">
          <el-row>
            <el-col :span="8" class="c_margin_top">
              <el-form-item label="溶剂:" :required="true">
                <el-button type="primary" size="mini" @click="clickEluentDialog"
                  >设置</el-button
                >
                <span
                  style="color: red; margin-left: 10px"
                  v-if="this.$store.state.showEluent"
                  >请完善溶剂信息</span
                >
              </el-form-item>
            </el-col>
            <el-col :span="8" class="c_margin_top">
              <el-form-item label="梯度:" :required="true">
                <el-button
                  type="primary"
                  size="mini"
                  @click="clickGradientDialog"
                  >设置</el-button
                >
                <span
                  style="color: red; margin-left: 10px"
                  v-if="this.$store.state.showGradient"
                  >请完善梯度信息</span
                >
              </el-form-item>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
      <el-divider></el-divider>
      <el-row class="c_margin_top" :gutter="20">
        <el-col :span="3">
          <h4>其他信息:</h4>
        </el-col>
        <el-col :span="20" class="c_margin_top">
          <el-row>
            <el-col :span="6">
              <el-form-item label="方法名称:">
                <el-input
                  type="primary"
                  size="mini"
                  v-model="MethodInfo.method_name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="分离时间(min):"
                prop="otherInfo.separateTime"
              >
                <el-input
                  type="primary"
                  size="mini"
                  v-model="MethodInfo.otherInfo.separateTime"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="溶剂消耗:">
                <el-button
                  type="primary"
                  size="mini"
                  @click="showSolventsConsume = true"
                  >设置</el-button
                >
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="分离图谱:" :required="true">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :limit="1"
                  :auto-upload="false"
                  list-type="picture"
                  :on-change="changeChromFile"
                  :on-remove="handleRemove"
                  :file-list="pngs"
                  accept=".jpg,.png"
                >
                  <el-button type="primary" size="mini">上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件
                  </div>
                </el-upload>
                <!-- <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl"></el-dialog> -->
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="备注:">
                <el-input
                  placeholder="请描述目标化合物的出峰位置"
                  clearable
                  type="primary"
                  size="mini"
                  v-model="MethodInfo.samplePeakAppearance"
                ></el-input>
                
                <!-- <el-dialog :visible.sync="dialogVisible"><img width="100%" :src="dialogImageUrl"></el-dialog> -->
              </el-form-item>
            </el-col>
          </el-row>
          <!-- <el-row>
            <el-col :span="8">
                <el-form-item  label="目标产物:" prop="text3">
                 <el-input style="margin-top: 7px;" size="mini" v-model="MethodInfo.text3">
                        <template slot="append">
                            <el-select v-model="MethodInfo.yieldUnit" class="headsearchselect" placeholder="单位:">
                                <el-option
                                        v-for="item in unitOpts"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value">
                                </el-option>
                            </el-select>
                        </template>
                    </el-input>
                </el-form-item>
            </el-col>
          </el-row> -->
        </el-col>
      </el-row>
    </el-form>
  </el-row>
</template>

<script>
import func from "../../../commons/func";
import { mapActions } from "vuex";

export default {
  name: "InputMethodInfo",
  data() {
    var loadAmount = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
      } else {
        if (Number(value) <= 0) {
          callback(new Error("请输入正数"));
        } else {
          if (/^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
            if (Math.trunc(value) > 999999999) {
              callback(new Error("整数部分不超过十位"));
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留两位小数"));
          }
        }
      }
    };
    var tempera = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
      } else {
        if (Number(value) <= 0) {
          callback(new Error("请输入正数"));
        } else {
          if (/^[0-9]+(.[0-9]{1,2})?$/.test(value)) {
            if (Math.trunc(value) > 999999999) {
              callback(new Error("整数部分不超过十位"));
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留两位小数"));
          }
        }
      }
    };
    var wave = (rule, value, callback) => {
      if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
        this.$message("检测波长请输入数字");
      } else {
        if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
          if (Math.trunc(value) <= 0) {
            callback(new Error("请输入正数"));
            this.$message("检测波长请输入正数");
          } else if (Math.trunc(value) > 800) {
            callback(new Error("最大值不能超过800"));
            this.$message("最大值不能超过800");
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入整数"));
          this.$message("检测波长请输入整数");
        }
      }
    };
    var flowRate = (rule, value, callback) => {
      if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
        this.$message("流量请输入数字");
      } else {
        if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
          if (Math.trunc(value) <= 0) {
            callback(new Error("请输入正数"));
            this.$message("流量请输入正数");
          } else if (Number(value) > 2000) {
            callback(new Error("最大值不能超过2000"));
            this.$message("最大值不能超过2000");
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入整数"));
          this.$message("流量请输入整数");
        }
      }
    };
    var cvValue = (rule, value, callback) => {
      if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
        this.$message("cv请输入数字");
      } else {
        if (Number(value) < 0) {
          callback(new Error("请输入正数"));
          this.$message("cv请输入正数");
        } else {
          if (/^[0-9]+(.[0-9]{1})?$/.test(value)) {
            if (Math.trunc(value) < 0) {
              callback(new Error("请输入正数"));
              this.$message("cv请输入正数");
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留一位小数"));
            this.$message("cv请保留一位小数");
          }
        }
      }
    };
    var per2Begin = (rule, value, callback) => {
      if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
        this.$message("百分比请输入数字");
      } else {
        if (Math.trunc(value) < 0) {
          callback(new Error("请输入正数"));
          this.$message("百分比请输入正数");
        } else {
          if (/^\d+(\.\d{0,1})?$/.test(value)) {
            if (Number(value) > 100) {
              callback(new Error("最大值不能超过100"));
              this.$message("最大值不能超过100");
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留一位小数"));
            this.$message("百分比请保留一位小数");
          }
        }
      }
    };
    var per2End = (rule, value, callback) => {
      if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
        this.$message("百分比请输入数字");
      } else {
        if (Math.trunc(value) < 0) {
          callback(new Error("请输入正数"));
          this.$message("百分比请输入正数");
        } else {
          if (/^\d+(\.\d{0,1})?$/.test(value)) {
            if (Number(value) > 100) {
              callback(new Error("最大值不能超过100"));
              this.$message("最大值不能超过100");
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留一位小数"));
            this.$message("百分比请保留一位小数");
          }
        }
      }
    };
    var per3 = (rule, value, callback) => {
      if (value === "" || value === null) {
        callback();
      } else if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
      } else {
        if (Math.trunc(value) < 0) {
          callback(new Error("请输入正数"));
          this.$message("请输入正数");
        } else {
          if (/^[0-9]+(.[0-9]{1})?$/.test(value)) {
            if (Number(value) > 15) {
              callback(new Error("第三通道不能大于15"));
              this.$message("第三通道不能大于15");
            } else {
              callback();
            }
          } else {
            callback(new Error("请保留一位小数"));
            this.$message("请保留一位小数");
          }
        }
      }
    };
    return {
      channelList: ["A", "B", "C", "D"],
      channelListInit: [],
      channelListInitThree: [],
      channelListFirst: [[]],
      channelListSecond: [[]],
      channelListThird: [[]],
      channelTypes: ["A", "B", "C", "D"],
      unitOpts: [
        {
          label: "g",
          value: "g",
        },
        {
          label: "mg",
          value: "mg",
        },
      ],
      rules: {
        atomizationTemperature: [
          { required: true, message: "请输入雾化温度", trigger: "blur" },
          { validator: tempera, trigger: "blur" },
        ],
        flashColumn: [
          { required: true, message: "请输入型号", trigger: "blur" },
        ],
        resolution: [
          { pattern: /^[0-9]*$/, message: "请输入数字", trigger: "blur" },
        ],
        loadAmount: [
          { required: true, message: "请输入上样量", trigger: "blur" },
          { validator: loadAmount, trigger: "blur" },
        ],
        wavelengthChA: [
          { required: true, message: "请输入检测波长1", trigger: "blur" },
          { validator: wave, trigger: "blur" },
        ],
        wavelengthChB: [
          { required: true, message: "请输入检测波长2", trigger: "blur" },
          { validator: wave, trigger: "blur" },
        ],
        "otherInfo.separateTime": {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (/^[0-9]*[1-9][0-9]*$/.test(value) == false) {
              callback(new Error("请输入正整数"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
        "sampleCollection.perCollectVol": {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (/^[0-9]*[1-9][0-9]*$/.test(value) == false) {
              callback(new Error("请输入正整数"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
        "otherInfo.solventsConsume.vol": {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (/^[0-9]*[1-9][0-9]*$/.test(value) == false) {
              callback(new Error("请输入正整数"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
        text3: {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (/^[0-9]*[1-9][0-9]*$/.test(value) == false) {
              callback(new Error("请输入正整数"));
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      },
      EluentRules: {
        nameCh: [
          { required: true, message: "请选择溶剂名称", trigger: "change" },
        ],
        channel: [{ required: true, message: "请选择管道", trigger: "change" }],
        polarity: [{ required: true, message: "请输入极性", trigger: "blur" }],
      },
      gradientRules: {
        begin_cv: [{ required: true, message: "", trigger: "blur" }],
        end_cv: [
          { required: true, message: "", trigger: "blur" },
          { validator: cvValue, trigger: "blur" },
        ],
        begin_time: [{ required: true, message: "", trigger: "blur" }],
        end_time: [{ required: true, message: "", trigger: "blur" }],
        channel_1: [{ required: true, message: "", trigger: "blur" }],
        channel_2: [{ required: true, message: "", trigger: "blur" }],
        begin_percent_2: [
          { required: true, message: "", trigger: "blur" },
          { validator: per2Begin, trigger: "blur" },
        ],
        end_percent_2: [
          { required: true, message: "", trigger: "blur" },
          { validator: per2End, trigger: "blur" },
        ],
        flow_rate: [
          { required: true, message: "", trigger: "blur" },
          { validator: flowRate, trigger: "blur" },
        ],
        percent_3: [{ validator: per3, trigger: "blur" }],
      },
      username: this.$store.state.username,
      // showFlowRateList: false,
      showGradientDialog: false,
      showSolventsConsume: false,
      showEluent: false,
      disabled: false,
      // columnFillerType: this.$store.state.sepaMethods.columnFillerType,
      processType: this.$store.state.sepaMethods.processType,
      // detectSettingType: this.$store.state.sepaMethods.detectSettingType,
      detectSettingType: [
        {
          value: "0",
          label: "UV",
        },
        {
          value: "1",
          label: "ELSD",
        },
      ],
      methodType: [
        {
          value: "0",
          label: "正相分离",
        },
        {
          value: "1",
          label: "反相分离",
        },
      ],
      channelN: [{ label: "N", value: "N" }],
      showModelDetails: false,
      simpleCollectType: this.$store.state.sepaMethods.simpleCollectType,
      // 梯度
      GradientListObj: {
        GradientList: [
          {
            begin_cv: "0.0",
            end_cv: "",
            flow_rate: "",
            begin_time: "",
            end_time: "",
            channel_1: "",
            channel_2: "",
            channel_3: "",
            percent_3: "",
            begin_percent_2: "",
            end_percent_2: "",
          },
        ],
      },
      // 分离参数
      MethodInfo: {
        text3: "",
        yieldUnit: "",
        extract_user: "",
        quote_number: 0,
        wavelengthChA: "", //检测方式UV
        wavelengthChB: "", //检测方式UV
        uuid: func.guid(),
        analysisColumn: "",
        method_time: new Date(),
        evaluate_level: "",
        method_name: "",
        loadAmount: "", //上样量
        loadAmountUnit: "",
        method_location: "",
        method_security: "",
        collectionThreshold: "",
        gradientType: 1,
        id: 0,
        is_self: "",
        project_uuid: func.guid(),
        collectionMode: "",
        create_time: "",
        method_type: "0",
        rawconPath: "", //整体合成图片找事
        spectrum_number: "",
        sampleWeight: "",
        create_user: "",
        flashColumn: "", //型号
        resolution: "", //标准分离度
        trailingFactor: "", //标准拖尾因子
        effectivePedals: "", //有效塔板数
        columns: [],
        //分离柱详细信息
        columnDetail: {
          flashColumn: "",
          cv: "",
          filler: "",
          aperture: "",
          catalogueName: "",
          particleSize: "",
          pressure: "",
          trailingFactorMin: "",
          trailingFactorMax: "",
          resolution: "",
          supplierName: "",
          length: "",
          innerDiameter: "",
          supplierId: "",
          brand: "", //品牌
        },
        solvents: [""], //洗脱溶剂(String[])
        detectSetting: "", //检测设置
        atomizationTemperature: "", //雾化温度(ELSD)检测设置时用到
        sampleCollection: {
          collectType: "", //收集类型 ：自动收集、手动收集
          perCollectVol: "", //每一容器收集体积
        },
        otherInfo: {
          separateTime: "", //分离时间(min)
          method_name: "",
          solventsConsume: [
            {
              solvents: "",
              vol: "",
            },
          ],
          remark: "",
        },
      },
      // 色谱图地址
      Chromatographic: "",
      pngs: [],
      chromList: [],
      columns: [],
      /**
       * 流动相、溶剂列表
       * */
      FlowPhase: [],
      flowPhaseTags: ["流动相A:", "流动相B:", "流动相C:"],
      FlashColumnList: [],
      supplierList: [],
      checkCv: true,
      grade: [],
      timeGrade: [],
    };
  },
  methods: {
    detectSettingChange() {
      if (this.MethodInfo.detectSetting == "0") {
        this.$refs["ruleForm"].clearValidate(["atomizationTemperature"]);
      }
      if (this.MethodInfo.detectSetting == "1") {
        this.$refs["ruleForm"].clearValidate(["wavelengthChA"]);
        this.$refs["ruleForm"].clearValidate(["wavelengthChB"]);
      }
    },
    valueChange() {
      this.$forceUpdate();
    },
    showDetails() {
      if (this.MethodInfo.flashColumn) {
        this.showModelDetails = true;
      } else {
        this.$message("请选择色谱柱型号");
      }
    },
    inputPercentChange(index) {
      if (this.GradientListObj.GradientList.length - 1 > index) {
        this.GradientListObj.GradientList[index + 1].begin_percent_2 =
          this.GradientListObj.GradientList[index].end_percent_2;
      }
    },
    inputFlowRateChange() {
      if (this.GradientListObj.GradientList[0].end_cv !== "") {
        this.GradientListObj.GradientList.forEach((item, index) => {
          if (this.checkCv) {
            this.inputCvChange(index);
          } else {
            this.inputTimeChange(index);
          }
        });
      }
    },
    inputChange() {
      if (
        this.MethodInfo.columnDetail.cv &&
        this.$store.state.clickGradient &&
        this.GradientListObj.GradientList[0].end_cv !== ""
      ) {
        if (this.checkCv) {
          this.GradientListObj.GradientList.forEach((item, index) => {
            item.end_time =
              (parseFloat(this.MethodInfo.columnDetail.cv) *
                (parseFloat(item.end_cv) - parseFloat(item.begin_cv))) /
                parseFloat(item.flow_rate) +
              parseFloat(item.begin_time);
            item.end_time = parseFloat(item.end_time).toFixed(1);
            if (this.GradientListObj.GradientList.length - 1 > index) {
              this.GradientListObj.GradientList[index + 1].begin_cv =
                this.GradientListObj.GradientList[index].end_cv;
              this.GradientListObj.GradientList[index + 1].begin_time =
                this.GradientListObj.GradientList[index].end_time;
            }
          });
        } else {
          this.GradientListObj.GradientList.forEach((item, index) => {
            item.end_cv =
              (parseFloat(this.MethodInfo.columnDetail.cv) *
                (parseFloat(item.end_time) - parseFloat(item.begin_time))) /
                parseFloat(item.flow_rate) +
              parseFloat(item.begin_cv);
            item.end_cv = parseFloat(item.end_cv).toFixed(1);
            if (this.GradientListObj.GradientList.length - 1 > index) {
              this.GradientListObj.GradientList[index + 1].begin_cv =
                this.GradientListObj.GradientList[index].end_cv;
              this.GradientListObj.GradientList[index + 1].begin_time =
                this.GradientListObj.GradientList[index].end_time;
            }
          });
        }
      }
    },
    inputCvChange(index) {
      if (this.GradientListObj.GradientList[index].flow_rate === "") {
        this.$message("请优先设置流速！");
        this.GradientListObj.GradientList[index].end_cv = "";
        return;
      }
      this.GradientListObj.GradientList[index].end_time =
        (parseFloat(this.MethodInfo.columnDetail.cv) *
          (parseFloat(this.GradientListObj.GradientList[index].end_cv) -
            parseFloat(this.GradientListObj.GradientList[index].begin_cv))) /
          parseFloat(this.GradientListObj.GradientList[index].flow_rate) +
        parseFloat(this.GradientListObj.GradientList[index].begin_time);
      this.GradientListObj.GradientList[index].end_time = parseFloat(
        this.GradientListObj.GradientList[index].end_time
      ).toFixed(1);
      if (this.GradientListObj.GradientList.length - 1 > index) {
        this.GradientListObj.GradientList[index + 1].begin_cv =
          this.GradientListObj.GradientList[index].end_cv;
        this.GradientListObj.GradientList[index + 1].begin_time =
          this.GradientListObj.GradientList[index].end_time;
      }
    },
    inputTimeChange(index) {
      if (this.GradientListObj.GradientList[index].flow_rate === "") {
        this.$message("请优先设置流速！");
        this.GradientListObj.GradientList[index].end_time = "";
        return;
      }
      this.GradientListObj.GradientList[index].end_cv =
        (parseFloat(this.GradientListObj.GradientList[index].flow_rate) *
          (parseFloat(this.GradientListObj.GradientList[index].end_time) -
            parseFloat(this.GradientListObj.GradientList[index].begin_time))) /
          parseFloat(this.MethodInfo.columnDetail.cv) +
        parseFloat(this.GradientListObj.GradientList[index].begin_cv);
      this.GradientListObj.GradientList[index].end_cv = parseFloat(
        this.GradientListObj.GradientList[index].end_cv
      ).toFixed(1);
      if (this.GradientListObj.GradientList.length - 1 > index) {
        this.GradientListObj.GradientList[index + 1].begin_time =
          this.GradientListObj.GradientList[index].end_time;
        this.GradientListObj.GradientList[index + 1].begin_cv =
          this.GradientListObj.GradientList[index].end_cv;
      }
    },
    channelChange() {
      let channelCheck = [];
      let lastArr = ["A", "B", "C", "D"];
      this.MethodInfo.solvents.forEach((ite) => {
        channelCheck.push(ite.channel);
      });
      channelCheck.forEach((item) => {
        lastArr = lastArr.filter((item1) => {
          return item1 != item;
        });
      });
      this.channelTypes = lastArr;
    },
    changeFirst(index) {
      this.channelListSecond[index] = this.channelListInit.filter((item) => {
        if (
          item.value === this.GradientListObj.GradientList[index].channel_1 ||
          item.value === this.GradientListObj.GradientList[index].channel_3
        ) {
          return;
        } else {
          return item;
        }
      });
      this.channelListThird[index] = this.channelListInitThree.filter(
        (item) => {
          if (
            item.value === this.GradientListObj.GradientList[index].channel_1 ||
            item.value === this.GradientListObj.GradientList[index].channel_2
          ) {
            return;
          } else {
            return item;
          }
        }
      );
    },
    changeSecond(index) {
      this.channelListFirst[index] = this.channelListInit.filter((item) => {
        if (
          item.value === this.GradientListObj.GradientList[index].channel_2 ||
          item.value === this.GradientListObj.GradientList[index].channel_3
        ) {
          return;
        } else {
          return item;
        }
      });
      this.channelListThird[index] = this.channelListInitThree.filter(
        (item) => {
          if (
            item.value === this.GradientListObj.GradientList[index].channel_2 ||
            item.value === this.GradientListObj.GradientList[index].channel_1
          ) {
            return;
          } else {
            return item;
          }
        }
      );
    },
    changeThird(index) {
      this.channelListFirst[index] = this.channelListInit.filter((item) => {
        if (
          item.value === this.GradientListObj.GradientList[index].channel_3 ||
          item.value === this.GradientListObj.GradientList[index].channel_2
        ) {
          return;
        } else {
          return item;
        }
      });
      this.channelListSecond[index] = this.channelListInit.filter((item) => {
        if (
          item.value === this.GradientListObj.GradientList[index].channel_3 ||
          item.value === this.GradientListObj.GradientList[index].channel_1
        ) {
          return;
        } else {
          return item;
        }
      });
    },
    clickCv() {
      if (this.MethodInfo.gradientType === 0) {
        this.MethodInfo.gradientType = 1;
      } else {
        this.MethodInfo.gradientType = 0;
      }
      this.checkCv = !this.checkCv;
      // console.log('change',this.MethodInfo.gradientType)
    },
    getSupplierList() {
      this.$api.post("/datacenter/getSupplierList", {}, (res) => {
        if (res.data) {
          if (res.data.code !== 200) {
            this.$message({
              type: "error",
              message: "获取供应商列表失败!",
            });
            return;
          }
          this.supplierList = res.data.data;
        }
      });
    },
    changeFlashColumn() {
      if (
        this.FlashColumnList.find(
          (item) => item.flashColumn === this.MethodInfo.flashColumn
        )
      ) {
        let details = {};
        details = this.FlashColumnList.find(
          (item) => item.flashColumn === this.MethodInfo.flashColumn
        );
        if (details.aperture) {
          this.MethodInfo.columnDetail.fillerAperture = details.aperture;
        } else {
          this.MethodInfo.columnDetail.fillerAperture = "";
        }
        if (details.particleSize) {
          this.MethodInfo.columnDetail.fillerParticleSize =
            details.particleSize;
        } else {
          this.MethodInfo.columnDetail.fillerParticleSize = "";
        }
        if (details.catalogueName) {
          this.MethodInfo.columnDetail.catalogueName = details.catalogueName;
        } else {
          this.MethodInfo.columnDetail.catalogueName = "";
        }
        if (details.pressure) {
          this.MethodInfo.columnDetail.pressure = details.pressure;
        } else {
          this.MethodInfo.columnDetail.pressure = "";
        }
        if (details.filler) {
          this.MethodInfo.columnDetail.fillerLabel = details.filler;
        } else {
          this.MethodInfo.columnDetail.fillerLabel = "";
        }
        if (details.innerDiameter && details.length) {
          this.MethodInfo.columnDetail.size =
            Math.round(details.innerDiameter) +
            "*" +
            Math.round(details.length);
        } else {
          this.MethodInfo.columnDetail.size = "";
        }
        if (details.cv) {
          this.MethodInfo.columnDetail.cv = details.cv;
        } else {
          this.MethodInfo.columnDetail.cv = "";
        }
        if (details.resolution) {
          this.MethodInfo.columnDetail.resolution = details.resolution;
        } else {
          this.MethodInfo.columnDetail.resolution = "";
        }
        if (details.trailingFactorMin && details.trailingFactorMax) {
          this.MethodInfo.trailingFactor = `${details.trailingFactorMin}-${details.trailingFactorMax}`;
        } else {
          this.MethodInfo.trailingFactor = "";
        }
        if (details.trailingFactorMin) {
          this.MethodInfo.columnDetail.trailingFactorMin =
            details.trailingFactorMin;
        } else {
          this.MethodInfo.columnDetail.trailingFactorMin = "";
        }
        if (details.trailingFactorMax) {
          this.MethodInfo.columnDetail.trailingFactorMax =
            details.trailingFactorMax;
        } else {
          this.MethodInfo.columnDetail.trailingFactorMax = "";
        }
        if (details.length) {
          this.MethodInfo.columnDetail.length = details.length;
        } else {
          this.MethodInfo.columnDetail.length = "";
        }
        if (details.innerDiameter) {
          this.MethodInfo.columnDetail.innerDiameter = details.innerDiameter;
        } else {
          this.MethodInfo.columnDetail.innerDiameter = "";
        }
        if (details.supplierId) {
          this.MethodInfo.columnDetail.brand = this.supplierList.find(
            (item) => item.id === details.supplierId
          ).supplierName;
        } else {
          this.MethodInfo.columnDetail.brand = "";
        }
        if (details.effectivePedals) {
          this.MethodInfo.effectivePedals = details.effectivePedals;
        } else {
          this.MethodInfo.effectivePedals = "";
        }

        this.updateMethodInfo(this.MethodInfo);
      } else {
        this.disabled = false;
        this.MethodInfo.columnDetail.fillerAperture = "";
        this.MethodInfo.columnDetail.fillerParticleSize = "";
        this.MethodInfo.columnDetail.catalogueName = "";
        this.MethodInfo.columnDetail.size = "";
        this.MethodInfo.columnDetail.cv = "";
        this.MethodInfo.columnDetail.brand = "";

        this.MethodInfo.columnDetail.trailingFactorMin = "";
        this.MethodInfo.columnDetail.trailingFactorMax = "";
        this.MethodInfo.columnDetail.resolution = "";
        this.MethodInfo.columnDetail.length = "";
        this.MethodInfo.columnDetail.innerDiameter = "";

        this.MethodInfo.trailingFactor = "";
        this.MethodInfo.effectivePedals = "";
        this.MethodInfo.resolution = "";
      }
    },
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    readySubmitFile(fileList) {
      //将准备提交的多张图片转为base64
      let _this = this;
      if (!(fileList instanceof Array) || fileList.length <= 0) {
        return false;
      }
      _this.fileMessage.fileNameArr = [];
      _this.fileMessage.fileBase64Arr = [];
      for (let i = 0; i < fileList.length; i++) {
        _this.fileMessage.fileNameArr.push(fileList[i].name);
        _this.getBase64(fileList[i].raw).then(
          (res) => {
            console.log("222", res);
            _this.fileMessage.fileBase64Arr.push(res);
          },
          (err) => {
            console.log(err, "转码失败");
          }
        );
      }
      return true;
    },
    getFlashColumnList() {
      this.$api.post(
        "/datacenter/getFlashListAll",
        { thirdCatalogueId: "", author: "", supplierId: "" },
        (res) => {
          if (res.data) {
            if (res.data.code !== 200) {
              this.$message({
                type: "error",
                message: "获取子规格失败!",
              });
              return;
            }
            this.FlashColumnList = res.data.data;
            if (
              this.FlashColumnList.find(
                (item) => item.flashColumn === this.MethodInfo.flashColumn
              )
            ) {
              this.disabled = true;
            } else {
              // console.log('flashColumn',this.FlashColumnList,this.MethodInfo.flashColumn)
              this.MethodInfo.flashColumn = "";
            }
          }
        }
      );
    },
    closeModelDetails() {
      this.submitColumnDetailForm("columnDetail");
    },

    changeSolvent(val, index) {
      this.FlowPhase.forEach((v) => {
        if (v.solvent === val) {
          this.MethodInfo.solvents[index].polarity = v.polarity;
          this.MethodInfo.solvents[index].id = v.id;
          this.MethodInfo.solvents[index].density = v.density;
        }
      });
      this.MethodInfo.solvents.forEach((v, i) => {
        const str = `${i - 1}EluentForm`;
        this.$refs[`${str}`][0].validate((valid) => {
          if (valid) {
            console.log(1111);
          }
        });
      });
    },
    submitColumnDetailForm(formName) {
      if (this.disabled) {
        this.showModelDetails = false;
      } else {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$store.commit("updateColumnDetail", true);
            this.showModelDetails = false;
          } else {
            this.$store.commit("updateColumnDetail", false);
            return false;
          }
        });
      }
    },
    resetForm() {
      // 梯度
      this.GradientListObj = {
        GradientList: [
          {
            begin_cv: "0.0",
            end_cv: "",
            flow_rate: "",
            begin_time: "0.0",
            end_time: "",
            channel_1: "",
            channel_2: "",
            channel_3: "",
            percent_3: "",
            begin_percent_2: "",
            end_percent_2: "",
          },
        ],
      };
      // 分离参数
      this.MethodInfo = {
        text3: "",
        yieldUnit: "mg",
        analysisColumn: "",
        atomizationTemperature: "",
        collectionMode: "",
        collectionThreshold: "",
        columnDetail: {
          flashColumn: "",
          cv: "",
          filler: "",
          aperture: "",
          catalogueName: "",
          particleSize: "",
          pressure: "",
          trailingFactorMin: "",
          trailingFactorMax: "",
          resolution: "",
          supplierName: "",
          length: "",
          innerDiameter: "",
          supplierId: "",
          brand: "",
          fillerLabel: "",
        },
        create_time: "",
        create_user: "",
        detectSetting: "",
        effectivePedals: "",
        evaluate_level: "",
        extract_user: "",
        flashColumn: null,
        gradientType: "",
        id: "",
        is_self: "",
        loadAmount: "",
        loadAmountUnit: "",
        loadType: "",
        method_location: "",
        method_name: "",
        method_security: "",
        method_time: "",
        method_type: "",
        otherInfo: {
          separateTime: "",
          solventsConsume: [{ solvents: "", vol: "" }],
        },
        project_uuid: "",
        quote_number: "",
        rawconPath: "",
        resolution: "",
        sampleCollection: { collectType: "", perCollectVol: "" },
        sampleWeight: "",
        solvents: [],
        spectrum_number: "",
        trailingFactor: "",
        uuid: "",
        wavelengthChA: "",
        wavelengthChB: "",
      };
      // 色谱图地址
      this.Chromatographic = "";
      this.pngs = [];
      // this.pngs=[],
      // this.chromList=[],
      // this.columns=[],
      /**
       * 流动相、溶剂列表
       * */
      // this.FlowPhase=[],
      // this.FlashColumnList=[],
      // this.supplierList=[],
      // this.grade=[],
      // this.timeGrade=[]
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.$store.commit("updateFlashColumn", true);
        } else {
          this.$store.commit("updateFlashColumn", false);
        }
      });
    },
    clickGradientDialog() {
      if (!this.MethodInfo.columnDetail.cv) {
        this.$message("请完善分离柱信息！");
        return;
      }
      if (this.MethodInfo.solvents.length < 2) {
        this.$message("溶剂最少两条");
        return;
      }
      if (this.MethodInfo.gradientType === 1) {
        this.checkCv = true;
        for (
          let index = 0;
          index < this.GradientListObj.GradientList.length;
          index++
        ) {
          if (this.GradientListObj.GradientList[index].end_cv != "") {
            this.GradientListObj.GradientList[index].end_time =
              (parseFloat(this.MethodInfo.columnDetail.cv) *
                (parseFloat(this.GradientListObj.GradientList[index].end_cv) -
                  parseFloat(
                    this.GradientListObj.GradientList[index].begin_cv
                  ))) /
                parseFloat(this.GradientListObj.GradientList[index].flow_rate) +
              parseFloat(this.GradientListObj.GradientList[index].begin_time);
            this.GradientListObj.GradientList[index].end_time = parseFloat(
              this.GradientListObj.GradientList[index].end_time
            ).toFixed(1);
            if (this.GradientListObj.GradientList.length - 1 > index) {
              this.GradientListObj.GradientList[index + 1].begin_cv =
                this.GradientListObj.GradientList[index].end_cv;
              this.GradientListObj.GradientList[index + 1].begin_time =
                this.GradientListObj.GradientList[index].end_time;
            }
          }
        }
      } else {
        this.checkCv = false;
        for (
          let index = 0;
          index < this.GradientListObj.GradientList.length;
          index++
        ) {
          if (this.GradientListObj.GradientList[index].end_time != "") {
            this.GradientListObj.GradientList[index].end_cv =
              (parseFloat(this.GradientListObj.GradientList[index].flow_rate) *
                (parseFloat(this.GradientListObj.GradientList[index].end_time) -
                  parseFloat(
                    this.GradientListObj.GradientList[index].begin_time
                  ))) /
                parseFloat(this.MethodInfo.columnDetail.cv) +
              parseFloat(this.GradientListObj.GradientList[index].begin_cv);
            this.GradientListObj.GradientList[index].end_cv = parseFloat(
              this.GradientListObj.GradientList[index].end_cv
            ).toFixed(1);
            if (this.GradientListObj.GradientList.length - 1 > index) {
              this.GradientListObj.GradientList[index + 1].begin_time =
                this.GradientListObj.GradientList[index].end_time;
              this.GradientListObj.GradientList[index + 1].begin_cv =
                this.GradientListObj.GradientList[index].end_cv;
            }
          }
        }
      }
      (this.showGradientDialog = true),
        (this.channelListInit = this.MethodInfo.solvents.map((item) => {
          return { label: item.nameCh, value: item.channel };
        }));
      this.channelListInitThree = [...this.channelN];
      if (this.channelListInit.length > 2) {
        this.channelListInitThree = this.channelListInitThree.concat(
          this.channelListInit
        );
      }
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        this.channelListFirst[index] = this.channelListInit;
        this.channelListSecond[index] = this.channelListInit;
        this.channelListThird[index] = this.channelListInitThree;
      }

      for (let i = 0; i < this.GradientListObj.GradientList.length; i++) {
        let channel1 = [];
        for (let j = 0; j < this.channelListFirst[i].length; j++) {
          channel1.push(this.channelListFirst[i][j].value);
        }
        if (
          channel1.indexOf(this.GradientListObj.GradientList[i].channel_1) == -1
        ) {
          this.GradientListObj.GradientList[i].channel_1 = "";
        }
        if (this.GradientListObj.GradientList[i].channel_2 != "") {
          let values = [];
          for (let j = 0; j < this.channelListSecond[i].length; j++) {
            values.push(this.channelListSecond[i][j].value);
          }
          if (
            values.indexOf(this.GradientListObj.GradientList[i].channel_2) == -1
          ) {
            this.GradientListObj.GradientList[i].channel_2 = "";
          }
        }
        if (this.GradientListObj.GradientList[i].channel_3 != "") {
          let values = [];
          for (let j = 0; j < this.channelListThird[i].length; j++) {
            values.push(this.channelListThird[i][j].value);
          }
          if (
            values.indexOf(this.GradientListObj.GradientList[i].channel_3) == -1
          ) {
            this.GradientListObj.GradientList[i].channel_3 = "";
          }
        }
      }
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        this.channelListFirst[index] = this.channelListFirst[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_2 !== obj.value
        );
        this.channelListFirst[index] = this.channelListFirst[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_3 !== obj.value
        );
        this.channelListSecond[index] = this.channelListSecond[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_1 !== obj.value
        );
        this.channelListSecond[index] = this.channelListSecond[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_3 !== obj.value
        );
        this.channelListThird[index] = this.channelListThird[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_1 !== obj.value
        );
        this.channelListThird[index] = this.channelListThird[index].filter(
          (obj) =>
            this.GradientListObj.GradientList[index].channel_2 !== obj.value
        );
      }
    },
    clickEluentDialog() {
      this.showEluentfunc();
      this.$store.commit("updateClickEluent", true);
      let channelCheck = [];
      let lastArr = ["A", "B", "C", "D"];
      this.MethodInfo.solvents.forEach((ite) => {
        channelCheck.push(ite.channel);
      });
      channelCheck.forEach((item) => {
        lastArr = lastArr.filter((item1) => {
          return item1 != item;
        });
      });
      this.channelTypes = lastArr;
    },
    closeEluent() {
      if (this.MethodInfo.solvents.length < 2) {
        if (
          this.MethodInfo.solvents[0].nameCh == "" &&
          this.MethodInfo.solvents[0].channel == ""
        ) {
          this.$store.commit("updateShowEluent", true);
          this.$message("溶剂最少两条");
          this.showEluent = false;
        } else {
          this.$message("溶剂最少两条");
        }
      } else if (this.MethodInfo.solvents.length == 2) {
        let el = [];
        for (let index = 0; index < this.MethodInfo.solvents.length; index++) {
          if (
            this.MethodInfo.solvents[index].nameCh === "" ||
            this.MethodInfo.solvents[index].channel === ""
          )
            el.push(1);
        }
        if (el.length > 0) {
          this.$store.commit("updateShowEluent", true);
          this.$message("完善溶剂信息");
        } else {
          this.$store.commit("updateShowEluent", false);
          this.showEluent = false;
        }
      } else {
        this.$store.commit("updateShowEluent", false);
        this.showEluent = false;
      }
    },
    finishEluent() {
      let count = 0;
      this.MethodInfo.solvents.forEach((v, i) => {
        const str = `${i - 1}EluentForm`;
        this.$refs[`${str}`][0].validate((valid) => {
          if (valid) {
            count++;
          }
        });
      });
      if (this.MethodInfo.solvents.length < 2) {
        this.$store.commit("updateShowEluent", true);
        this.$message("溶剂最少两条");
      } else if (count === this.MethodInfo.solvents.length) {
        this.$store.commit("updateShowEluent", false);
        this.showEluent = false;
      } else {
        this.$store.commit("updateShowEluent", true);
      }
    },

    closeGradient() {
      this.grade = [];
      this.timeGrade = [];
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        if (
          Number(this.GradientListObj.GradientList[index].begin_cv) >
          Number(this.GradientListObj.GradientList[index].end_cv)
        ) {
          this.grade.push(1);
        }
      }
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        if (
          Number(this.GradientListObj.GradientList[index].begin_time) >
          Number(this.GradientListObj.GradientList[index].end_time)
        ) {
          this.timeGrade.push(1);
        }
      }
      if (this.grade.length > 0) {
        this.$message("end不能比begin小");
      } else if (this.timeGrade.length > 0) {
        this.$message("end不能比begin小");
      } else {
        this.$refs.GradientList.validate((valid) => {
          if (valid) {
            this.$store.commit("updateShowGradient", false);
            this.showGradientDialog = false;
          } else {
            this.$store.commit("updateShowGradient", true);
          }
        });
      }
    },
    finishGradient() {
      this.grade = [];
      this.timeGrade = [];
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        if (
          Number(this.GradientListObj.GradientList[index].begin_cv) >
          Number(this.GradientListObj.GradientList[index].end_cv)
        ) {
          this.grade.push(1);
        }
      }
      for (
        let index = 0;
        index < this.GradientListObj.GradientList.length;
        index++
      ) {
        if (
          Number(this.GradientListObj.GradientList[index].begin_time) >
          Number(this.GradientListObj.GradientList[index].end_time)
        ) {
          this.timeGrade.push(1);
        }
      }
      if (this.grade.length > 0) {
        this.$message("end不能比begin小");
      } else if (this.timeGrade.length > 0) {
        this.$message("end不能比begin小");
      } else {
        this.$refs.GradientList.validate((valid) => {
          if (valid) {
            this.$store.commit("updateShowGradient", false);
            this.showGradientDialog = false;
          } else {
            this.$store.commit("updateShowGradient", true);
          }
        });
      }
    },
    addRow: function () {
      let lastRow =
        this.GradientListObj.GradientList[
          this.GradientListObj.GradientList.length - 1
        ];
      if (Number(lastRow.end_percent_2) > 100) {
        this.$message("梯度不能超过100！");
      } else {
        if (Number(lastRow.end_cv) < Number(lastRow.begin_cv)) {
          this.$message("end不能比begin小");
        } else if (Number(lastRow.end_time) < Number(lastRow.begin_time)) {
          this.$message("end不能比begin小");
        } else {
          if (
            ((lastRow.begin_cv.toString() != "" && lastRow.end_cv != "") ||
              (lastRow.begin_time.toString() != "" &&
                lastRow.end_time != "")) &&
            lastRow.flow_rate != "" &&
            lastRow.channel_1 != "" &&
            lastRow.channel_2 != "" &&
            lastRow.begin_percent_2 != "" &&
            lastRow.channel_2 != "" &&
            lastRow.end_percent_2 != ""
          ) {
            this.GradientListObj.GradientList.push({
              begin_cv: lastRow.end_cv,
              end_cv: "",
              flow_rate: lastRow.flow_rate,
              begin_time: lastRow.end_time,
              end_time: "",
              channel_1: lastRow.channel_1,
              channel_2: lastRow.channel_2,
              channel_3: lastRow.channel_3 == "N" ? "N" : "",
              percent_3: lastRow.percent_3,
              begin_percent_2: lastRow.end_percent_2,
              end_percent_2: "",
            });
            // this.channelListInit = this.MethodInfo.solvents.map(item => {
            //   return {label: item.nameCh,value:item.channel}
            // })
            // this.channelListInitThree=[...this.channelN]
            // if(this.channelListInit.length>2){
            //   this.channelListInitThree =  this.channelListInitThree.concat(this.channelListInit)
            // }
            // for (let index = 0; index < this.GradientListObj.GradientList.length; index++) {
            //      this.channelListFirst[index] = this.channelListInit
            //      this.channelListSecond[index] = this.channelListInit
            //      this.channelListThird[index] = this.channelListInitThree
            // }
            this.channelListFirst.push([
              ...this.channelListFirst[
                this.GradientListObj.GradientList.length - 2
              ],
            ]);
            this.channelListSecond.push([
              ...this.channelListSecond[
                this.GradientListObj.GradientList.length - 2
              ],
            ]);
            this.channelListThird.push([
              ...this.channelListThird[
                this.GradientListObj.GradientList.length - 2
              ],
            ]);
            //  console.log(this.channelListFirst,this.channelListSecond,this.channelListThird)
          } else {
            this.$message("请完善上一条数据！");
          }
        }
      }
    },
    addSolVolRow: function () {
      let lastRow =
        this.MethodInfo.otherInfo.solventsConsume[
          this.MethodInfo.otherInfo.solventsConsume.length - 1
        ];
      if (lastRow.solvents == "" || lastRow.vol == "") {
        this.$message("请完善上一条");
      }
      if (lastRow.solvents != "" && lastRow.vol != "") {
        if (!Number(lastRow.vol) && Number(lastRow.vol) !== 0) {
          this.$message("请输入数字");
        } else if (Number(lastRow.vol) < 0) {
          this.$message("请输入正数");
        } else if (/^[0-9]+(.[0-9]{1})?$/.test(lastRow.vol)) {
          this.MethodInfo.otherInfo.solventsConsume.push({
            solvents: "",
            vol: "",
          });
        } else {
          this.$message("请保留一位小数");
        }
      }
    },
    finishConsume: function () {
      let lastRow =
        this.MethodInfo.otherInfo.solventsConsume[
          this.MethodInfo.otherInfo.solventsConsume.length - 1
        ];
      if (lastRow.solvents == "" || lastRow.vol == "") {
        this.$message("请填写完整");
      }
      if (lastRow.solvents != "" && lastRow.vol != "") {
        if (!Number(lastRow.vol) && Number(lastRow.vol) !== 0) {
          this.$message("请输入数字");
        } else if (Number(lastRow.vol) < 0) {
          this.$message("请输入正数");
        } else if (/^[0-9]+(.[0-9]{1})?$/.test(lastRow.vol)) {
          this.showSolventsConsume = false;
        } else {
          this.$message("请保留一位小数");
        }
      }
    },
    closeConsume: function () {
      let lastRow =
        this.MethodInfo.otherInfo.solventsConsume[
          this.MethodInfo.otherInfo.solventsConsume.length - 1
        ];
      if (lastRow.solvents == "" && lastRow.vol == "") {
        this.showSolventsConsume = false;
      }
      if (lastRow.solvents != "" && lastRow.vol != "") {
        if (!Number(lastRow.vol) && Number(lastRow.vol) !== 0) {
          this.$message("请输入数字");
          this.MethodInfo.otherInfo.solventsConsume = [
            {
              solvents: "",
              vol: "",
            },
          ];
          this.showSolventsConsume = false;
        } else if (Number(lastRow.vol) < 0) {
          this.$message("请输入正数");
          this.MethodInfo.otherInfo.solventsConsume = [
            {
              solvents: "",
              vol: "",
            },
          ];
          this.showSolventsConsume = false;
        } else if (/^[0-9]+(.[0-9]{1})?$/.test(lastRow.vol)) {
          this.showSolventsConsume = false;
        } else {
          this.$message("请保留一位小数");
          this.MethodInfo.otherInfo.solventsConsume = [
            {
              solvents: "",
              vol: "",
            },
          ];
          this.showSolventsConsume = false;
        }
      }
    },
    deleteRow: function (index) {
      if (this.GradientListObj.GradientList.length >= 2) {
        this.GradientListObj.GradientList.splice(index, 1);
        this.channelListFirst.splice(index, 1);
        this.channelListSecond.splice(index, 1);
        this.channelListThird.splice(index, 1);
        if (index === 0) {
          this.GradientListObj.GradientList[0].begin_cv = "0.0";
          this.GradientListObj.GradientList[0].begin_time = "0.0";
          if (this.checkCv) {
            this.inputCvChange(index);
          } else {
            this.inputTimeChange(index);
          }
        } else if (this.GradientListObj.GradientList.length !== index) {
          this.GradientListObj.GradientList[index].begin_cv =
            this.GradientListObj.GradientList[index - 1].end_cv;
          this.GradientListObj.GradientList[index].begin_time =
            this.GradientListObj.GradientList[index - 1].end_time;
          this.GradientListObj.GradientList[index].begin_percent_2 =
            this.GradientListObj.GradientList[index - 1].end_percent_2;
          if (this.checkCv) {
            this.inputCvChange(index);
          } else {
            this.inputTimeChange(index);
          }
        }
      }
    },
    deleteSolVolRow: function (index) {
      if (this.MethodInfo.otherInfo.solventsConsume.length >= 2) {
        this.MethodInfo.otherInfo.solventsConsume.splice(index, 1);
      }
    },
    changeChromFile(file, fileList) {
      this.Chromatographic = "";
      fileList.forEach(async (item) => {
        const img = await this.getBase64(item.raw);
        let url = img.substring(img.indexOf(",") + 1).replaceAll(" ", "+");
        this.Chromatographic = url;
        // this.SampleInfo.TargetPic=img
      });
    },
    handleRemove() {
      this.Chromatographic = "";
    },
    onChromUploadSuccess: function (res, file) {
      if (res.code == 200) {
        let fileVo = res.data[0];
        this.Chromatographic = fileVo.path;
        this.chromList = [file];
      }
    },
    beforeChromcRemove: function (file, fileList) {
      this.chromList = fileList;
      if (this.chromList.length === 0) {
        this.Chromatographic = "";
      }
    },
    showEluentfunc: function () {
      if (this.MethodInfo.solvents.length == 0) {
        this.MethodInfo.solvents.push({
          channel: "",
          nameCh: "",
          polarity: 0,
        });
      }
      this.showEluent = true;
    },
    addEluentFunc: function () {
      if (this.MethodInfo.solvents.length > 3) {
        this.$message("溶剂信息不超过四条");
        return;
      } else {
        this.channelChange();
        if (
          this.MethodInfo.solvents[this.MethodInfo.solvents.length - 1]
            .channel &&
          this.MethodInfo.solvents[this.MethodInfo.solvents.length - 1].nameCh
        ) {
          this.MethodInfo.solvents.push({
            channel: "",
            nameCh: "",
            polarity: 0,
            id: "",
            density: "",
          });
        } else {
          this.$message("请完善上一条溶剂信息");
        }
      }
    },
    popEluentFunc: function () {
      if (this.MethodInfo.solvents.length > 1) {
        this.MethodInfo.solvents.pop();
      }
      let channelCheck = [];
      let lastArr = ["A", "B", "C", "D"];
      this.MethodInfo.solvents.forEach((ite) => {
        channelCheck.push(ite.channel);
      });
      channelCheck.forEach((item) => {
        lastArr = lastArr.filter((item1) => {
          return item1 != item;
        });
      });
      this.channelTypes = lastArr;
    },
    ...mapActions("sepaMethods", [
      "updateFlashColumnList",
      "updateGradientList",
      "updateMethodInfo",
      "updateChromatographic",
      "updateEvaluateSet",
    ]),
  },
  created() {
    this.GradientListObj.GradientList =
      this.$store.state.sepaMethods.GradientList;
    this.MethodInfo = this.$store.state.sepaMethods.MethodInfo;
    this.Chromatographic = this.$store.state.sepaMethods.Chromatographic;
    this.textSet = this.$store.state.sepaMethods.EvaluateSet;
    if (this.Chromatographic != "" && this.Chromatographic != undefined) {
      this.pngs = [
        {
          name: "分离图谱",
          url: `data:image/png;base64,${this.Chromatographic}`,
        },
      ];
    }
    if (this.MethodInfo.otherInfo == undefined) {
      this.MethodInfo.otherInfo = {
        separateTime: "",
        solventsConsume: [
          {
            solvents: "",
            vol: "",
          },
        ],
      };
    }
    this.$api.get("/datacenter/getSolventList ", {}, (res) => {
      if (res.data.code == 200) {
        this.FlowPhase = res.data.data;
        this.$store.commit("updateFlowPhaseList", res.data.data);
      } else {
        this.$message.error("获取溶剂列表失败");
      }
    });
    this.getFlashColumnList();
    this.getSupplierList();
    if (this.MethodInfo.solvents.length > 1) {
      this.$store.commit("updateClickEluent", true);
    }
    if (this.GradientListObj.GradientList.length > 0) {
      this.$store.commit("updateClickGradient", true);
    }
    console.log(this.MethodInfo)
  },
  watch: {
    textSet: {
      handler() {
        this.updateEvaluateSet(this.textSet);
      },
      deep: true,
    },
    GradientList: {
      handler() {
        this.updateGradientList(this.GradientListObj.GradientList);
      },
      deep: true,
    },
    // FlashColumnList: {
    //   handler() {
    //     this.updateFlashColumnList(this.FlashColumnList)
    //   },
    //   deep: true,
    // },
    MethodInfo: {
      handler() {
        this.updateMethodInfo(this.MethodInfo);
      },
      deep: true,
    },
    Chromatographic: {
      handler() {
        this.updateChromatographic(this.Chromatographic);
      },
      deep: true,
    },
    "MethodInfo.columnDetail.cv": {
      handler() {
        this.inputChange();
      },
      deep: true,
    },
  },
};
</script>

<style scoped>
@import "../../../assets/element-component.css";
.border {
  border-bottom: solid 1px #cccccc;
}
.c_margin_top {
  margin-top: 15px;
}
.border_margin_top_bottom {
  border: solid 1px #cccccc;
  margin-top: 15px;
  margin-bottom: 15px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.el-dialog-header-box {
  display: flex;
  flex-direction: row;
}
.dialog-title-block {
  background-color: #3399ff;
  width: 4px;
  height: 20px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
}
.dialog-title-text {
  display: flex;
  align-items: center;
  margin-left: 5px;
  font-weight: 700;
  margin-bottom: 20px;
}
::v-deep .el-dialog--center {
  height: auto;
  width: auto;
  max-height: 800px;
  overflow-y: auto;
  overflow-x: auto;
  max-width: 820px;
}
::v-deep .el-dialog__body {
  padding: 0 !important;
}
/* .flow /deep/.el-dialog__body {
  padding: 30px 20px !important
} */
.solvent /deep/.el-dialog__body {
  padding: 30px 20px !important;
}
.table-form /deep/.el-form-item__content {
  width: 100%;
  display: flex;
  align-items: center;
}
.gradientListDialog /deep/ .el-form-item__error {
  display: none;
}
</style>
